<template>
  <div class="main-wrapper">
    <main class="main-content" role="main">
      <h2>Unser Eisbechersortiment</h2>
      <p>Vielfältig, kreativ und bewährt</p>

      <section class="section section-1">
        <h2>Die Klassiker</h2>
        <p>Tradionelle Eiskreationen</p>
      </section>

      <section class="section teaser-articles">
        <article class="teaser-box">
          <img src="@/assets/img/eisbecher-gelb.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h3>Früchte-Becher</h3>
            <p>3 Kugeln Eis, gemischte Früchte und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
            <img src="@/assets/img/eisbecher-lila.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h2>Amarena-Becher</h2>
            <p>3 Kugeln Eis, Amarenakirschen und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
          <img src="@/assets/img/eisbecher-rot.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h3>Erdbeer</h3>
            <p>3 Kugeln Eis, frische Erdbeeren und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
<!--          <img src="@/assets/img/eisbecher-rumtopf.jpg" alt="Dummy-Bild" /> -->
          <div class="box-inner">
            <h2>Rumtopf-Becher</h2>
            <p>3 Kugeln Eis, eingelegte Früchte aus dem Rumtopf und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
          <img src="@/assets/img/eisbecher-gelb.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h2>Früchtebecher</h2>
            <p>3 Kugeln Eis, gemischte Früchte und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
          <img src="@/assets/img/eisbecher-lila.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h2>Amarenabecher</h2>
            <p>3 Kugeln Eis, Amarenakirschen und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>

        <article class="teaser-box">
          <img src="@/assets/img/eisbecher-rot.jpg" alt="Dummy-Bild" />
          <div class="box-inner">
            <h2>Erdbeerbecher</h2>
            <p>3 Kugeln Eis, frische Erdbeeren und Sahne</p>
            <p class="preis">x,xx€</p>
          </div>
        </article>
        
      </section>

      <section class="section teaser-articles"></section>
    </main>

  </div>
</template>

<script>
export default {
  name: "ZweiSpaltenView",
  data() {
    return {};
  },
  methods: {}
};
</script>

<style scoped>
/*
@import "../../assets/basis.css";
@import "../../assets/layout-fix.css";
*/
@import "https://fonts.googleapis.com/css?family=Raleway:500|Roboto:300";
@import "../../assets/css/normalize.css";
@import "../../assets/css/atmosphere.css";
@import "../../assets/css/layout.css";

.box-inner .preis {
  color:rgb(35, 141, 228);
  font-size: 1.5em;
  text-align: right;
}

.section.teaser-articles {
  overflow: auto;
  padding: 0;
  margin-top: 4rem;
}

.teaser-box img {
  width: 100%;
  height: auto;
}
.teaser-box {
  border: 1px solid #ddd;
  margin: 0 0 1em 0;
}

.box-inner {
  padding: 0;
}

@media screen and (min-width: 25em) {
  .teaser-box {
    overflow: auto;
  }
  .teaser-box img {
    width: 45%;
    float: left;
    margin: 1em;
  }
  .box-inner {
    line-height: 1.3;
  }
}

/* ----------------------------------------------------------------------------- *
 *                           Styles der Tabletversion                            *
 *                            640px / 16px/em = 40em                             *
 * ----------------------------------------------------------------------------- */
@media screen and (min-width: 40em) {
  .teaser-box img {
    width: 100%;
    float: none;
    margin: 0;
  }
  /* Wenn der Screen breiter wird werden 2 Teaserboxen nebeneinander dargestellt. */
  .teaser-box {
    float: left;
    margin-right: 4%;
    margin-bottom: 2em;
    width: 48%;
  }
  /* Bei jeder zweiten Teaserbox wird das margin auf 0 gesetzt. 
   * :nth-of-type(2n+2) entspricht :nth-of-type(even) */ 
.teaser-box:nth-of-type(even) {
    margin-right: 0;
  }
}

/* ----------------------------------------------------------------------------- *
 *                          Styles für größere Tablets Desktops                           *
 * ----------------------------------------------------------------------------- */
@media screen and (min-width: 52em) {
  .teaser-box img {
    width: 80%;
    height: auto;
    float: none;
    margin: 0;
  }
  /* Wenn der Screen breiter wird werden 4 Teaserboxen nebeneinander dargestellt. */
  .teaser-box {
    float: left;
    height: 400px;
    margin-right: 1%;
    margin-bottom: 2em;
    width: 32%;
  }
  /* Bei jeder zweiten Teaserbox wird das margin auf 0 gesetzt. 
   * :nth-of-type(2n+2) entspricht :nth-of-type(even) */ 
 .teaser-box:nth-of-type(even) {
    margin-right: 1%;
  }
 .teaser-box:nth-of-type(3n+3) {
    margin-right: 0%;
  }
}
/* ----------------------------------------------------------------------------- *
 *                          Styles für kleine Desktops                           *
 *                           1024px / 16px/em = 64em                             *
 * ----------------------------------------------------------------------------- */
@media screen and (min-width: 64em) {
  .teaser-box img {
    width: 90%;
    height: auto;
    float: none;
    margin: 0;
  }
  /* Wenn der Screen breiter wird werden 4 Teaserboxen nebeneinander dargestellt. */
  .teaser-box {
    float: left;
    height: 375px;
    margin-right: 1%;
    margin-bottom: 2em;
    width: 24%;
  }
  /* Bei jeder zweiten Teaserbox wird das margin auf 0 gesetzt. 
   * :nth-of-type(2n+2) entspricht :nth-of-type(even) */ 
 .teaser-box:nth-of-type(even) {
    margin-right: 1%;
  }
 .teaser-box:nth-of-type(3n+3) {
    margin-right: 1%;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/eisart/sortiment.vue